<template>
  <div class="mainPage">
    <div class="mainPageContent">
      <div class="contentPanel">
        <div class="headerLogo">
          <img
            src="../../assets/logo_b.png"
            alt="Osmose"
            @click="openDashboard()"
          />
        </div>

        <div class="formList">
            <h6 class="poleId">
                <strong>Pole ID: </strong>{{
              damageData.poleData !== undefined
                ? damageData.poleData.poleId
                : ""
                }}
            </h6>
            <div class="textCenter info1 fnt24">Add Damage Detail</div>
            <div class="damageCard repeatCard">
                <div class="Box1">
                    <div class="listBox">
                        <img src="../../assets/arc3.png" alt="Hollow Pole" />
                        <div class="boxTitle">Hollow Pole</div>
                    </div>
                    <div class="textCenter fntBold16">
                        Enter Shell For Each Orientation
                    </div>
                </div>
                <div class="damageDet">
                    <div class="formGroup">
                        <img src="../../assets/arc2.png"
                             alt="Hollow Pole"
                             :style="`transform: rotate(0deg);`"
                             class="imgIcon" />
                        <label>+LoL </label>
                        <input title=""
                               type="number"
                               min="0"
                               v-bind:readonly="readOnly"
                               class="formControl spinNone"
                               v-model="damage.shellQuads.shellLoL"
                               required
                               placeholder="Enter Value"
                               @keypress="decimalPoint($event, damage.SHELL)"
                               @paste="decimalPoint($event, damage.SHELL)" />
                        <span class="ml-2">inches</span>
                    </div>
                    <div class="formGroup">
                        <img src="../../assets/arc2.png"
                             alt="Hollow Pole"
                             :style="`transform: rotate(270deg);`"
                             class="imgIcon" />
                        <label>90 </label>
                        <input title=""
                               type="number"
                               min="0"
                               class="formControl spinNone"
                               v-model="damage.shellQuads.shell90"
                               v-bind:readonly="readOnly"
                               required
                               placeholder="Enter Value"
                               @keypress="decimalPoint($event, damage.SHELL)"
                               @paste="decimalPoint($event, damage.SHELL)" />
                        <span class="ml-2">inches</span>
                    </div>
                    <div class="formGroup">
                        <img src="../../assets/arc2.png"
                             alt="Hollow Pole"
                             :style="`transform: rotate(180deg);`"
                             class="imgIcon" />
                        <label>-LoL </label>
                        <input title=""
                               type="number"
                               min="0"
                               class="formControl spinNone"
                               v-model="damage.shellQuads.shell_LoL"
                               v-bind:readonly="readOnly"
                               required
                               placeholder="Enter Value"
                               @keypress="decimalPoint($event, damage.SHELL)"
                               @paste="decimalPoint($event, damage.SHELL)" />
                        <span class="ml-2">inches</span>
                    </div>
                    <div class="formGroup">
                        <img src="../../assets/arc2.png"
                             alt="Hollow Pole"
                             :style="`transform: rotate(90deg);`"
                             class="imgIcon" />
                        <label>-90 </label>
                        <input title=""
                               type="number"
                               min="0"
                               class="formControl spinNone"
                               v-model="damage.shellQuads.shell_90"
                               v-bind:readonly="readOnly"
                               required
                               placeholder="Enter Value"
                               @keypress="decimalPoint($event, damage.SHELL)"
                               @paste="decimalPoint($event, damage.SHELL)" />
                        <span class="ml-2">inches</span>
                    </div>
                    <div v-if="!formValid" class="error">{{ errMsg }}</div>
                </div>
            </div>
            <button class="btnblue" v-if="allowEditting" @click="onSave">SAVE</button>
            <button class="btnblue" v-if="allowEditting==false" @click="onDone">DONE</button>
            <div class="textCenter" v-if="allowEditting" @click="onCancel">
                <a href="javascript: void(0);" class="backLink txtUppercase">
                    CANCEL
                </a>
            </div>
        </div>
      </div>
      <shared-footer></shared-footer>
      <div class="popUp" v-if="popup">
        <div class="popUpBox">
          <p class="popupText">{{ popupMsg }}</p>
          <div class="modalFooter">
            <button class="btnRounded" v-on:click="closePrompt()">
              CANCEL
            </button>
            &nbsp;&nbsp;
            <button class="btnRoundedFull" v-on:click="confirmPrompt()">
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SimpleIDB from "../../api/indexedDBService.js";
import SharedFooter from "../SharedFooter.vue";
import { v4 as uuidv4 } from "uuid";
import { store } from "../../store/index.js";
import { mapGetters } from "vuex";
import Eruda from 'eruda';

export default {
  name: "DamageDetail",

  data: () => ({
    damageData: {},
    damage: {
      ID: "",
      TYPE: "HollowPole",
      ORIENT: "",
      ARCLEN: "",
      SHELL: "",
      DEPTH: "",
      SOURCE: "Manual",
      shellQuads: {
        shellLoL: "",
        shell90: "",
        shell_LoL: "",
        shell_90: "",
      },
    },
    formValid: false,
    popup: false,
    popupMsg: "",
    errMsg: "",
      clearEnPoc: false,
      allowEditting: true,
      readOnly: false,
      fromFulcrum: false
  }),

  components: {
    "shared-footer": SharedFooter,
  },

  computed: {
    ...mapGetters(["getDamageRecord"]),
  },

  mounted() {
    this.damageData = JSON.parse(this.getDamageRecord);
    this.radius =
      parseFloat(this.damageData.poleData.origCircumference) / 3.14 / 2;

    this.damage.ARCLEN =
      Math.ceil(
        (parseFloat(this.damageData.poleData.origCircumference) / 4) * 2
      ) / 2;

    this.damage.DEPTH = Math.round(this.radius * 0.8 * 2) / 2;

    if (this.damageData.damage) {
      this.damage.ORIENT = this.damageData.damage.ORIENT;
      this.damage.ARCLEN = this.damageData.damage.ARCLEN;
      this.damage.SHELL = this.damageData.damage.SHELL;
      this.damage.DEPTH = this.damageData.damage.DEPTH;
      this.damage.shellQuads = this.damageData.damage.shellQuads;
    }
      //debugger;
    if (
      JSON.stringify(this.damageData.poleData.damages).toLowerCase().includes(
        '"type":"enclosedpocket"'
      )
    ) {
      this.clearEnclosedPocketAlert();
    }
  },
        created() {

            if (localStorage.getItem("ErudaEnabled") === "Yes")
                Eruda.init();
            this.fromFulcrum = store.getters.fromFulcrum;
          
            if (this.fromFulcrum) {
                this.allowEditting = (localStorage.getItem("readOnly") == "false");
                this.readOnly = !this.allowEditting;
            }
        },
  methods: {
    openDashboard() {
      this.$router.replace("/dashboard");
    },

    closePrompt() {
      this.popup = false;
      if (this.clearEnPoc) this.$router.go(-1);
    },

    confirmPrompt() {
      this.popup = false;
      if (!this.clearEnPoc) this.$router.go(-1);
    },

    onSave() {
      this.validateDamage();
      },
      onDone() {
          this.backToEvaluation();
      },

    validateDamage() {
      this.validateShell();
      if (this.formValid) {
        this.damage.UPDATEDON = new Date();
        if (this.clearEnPoc) this.removeEnclosedPockets();
        else this.saveDamage();
      }
    },

    validateShell() {
      if (!this.damage.shellQuads.shellLoL) {
        this.emptyShell("+LoL");
      } else if (!this.damage.shellQuads.shell90) {
        this.emptyShell("90");
      } else if (!this.damage.shellQuads.shell_LoL) {
        this.emptyShell("-LoL");
      } else if (!this.damage.shellQuads.shell_90) {
        this.emptyShell("-90");
      } else {
        this.damage.shellQuads.shellLoL =
          Math.round(parseFloat(this.damage.shellQuads.shellLoL) * 2) / 2;
        this.damage.shellQuads.shell90 =
          Math.round(parseFloat(this.damage.shellQuads.shell90) * 2) / 2;
        this.damage.shellQuads.shell_LoL =
          Math.round(parseFloat(this.damage.shellQuads.shell_LoL) * 2) / 2;
        this.damage.shellQuads.shell_90 =
          Math.round(parseFloat(this.damage.shellQuads.shell_90) * 2) / 2;
        if (
          this.damage.shellQuads.shellLoL < 0.5 ||
          this.damage.shellQuads.shellLoL > this.damage.DEPTH
        ) {
          this.shellOutOfRange("+LoL");
        } else if (
          this.damage.shellQuads.shell90 < 0.5 ||
          this.damage.shellQuads.shell90 > this.damage.DEPTH
        ) {
          this.shellOutOfRange("90");
        } else if (
          this.damage.shellQuads.shell_LoL < 0.5 ||
          this.damage.shellQuads.shell_LoL > this.damage.DEPTH
        ) {
          this.shellOutOfRange("-LoL");
        } else if (
          this.damage.shellQuads.shell_90 < 0.5 ||
          this.damage.shellQuads.shell_90 > this.damage.DEPTH
        ) {
          this.shellOutOfRange("-90");
        } else {
          this.damage.SHELL = 0;
          // parseFloat(this.damage.shellQuads.shellLoL) +
          // parseFloat(this.damage.shellQuads.shell90) +
          // parseFloat(this.damage.shellQuads.shell_LoL) +
          // parseFloat(this.damage.shellQuads.shell_90);
          this.shellErr = false;
          this.formValid = true;
        }
      }
    },

    emptyShell(orient) {
      this.errMsg = "Shell empty for orientation " + orient;
      this.shellErr = true;
      this.formValid = false;
    },

    shellOutOfRange(orient) {
      this.errMsg = "Shell out of range for orientation " + orient;
      this.shellErr = true;
      this.formValid = false;
    },

      clearEnclosedPocketAlert() {
          //debugger;
      this.popupMsg = "Enclosed pockets will be removed. Continue?";
      this.clearEnPoc = true;
      this.popup = true;
    },

    removeEnclosedPockets() {
      this.clearEnPoc = false;
      let damageArray = this.damageData.poleData.damages.slice();
        damageArray.forEach((damage, index) => {
            //debugger;
            if (damage.type == "EnclosedPocket" || damage.TYPE == "EnclosedPocket") {
          this.damageData.poleData.damages.splice(
            this.damageData.poleData.damages.indexOf(damage),
            1
          );
        }
        if (index === damageArray.length - 1) this.saveDamage();
      });
    },

    saveDamage() {
        let damageKey = uuidv4();
        //debugger;
      //let damageRecord = {
      //  damageID: damageKey,
      //  type: this.damage.TYPE,
      //};
        if (!this.damageData.damage) {
            this.damage.ID = damageKey;
        } else {
            this.damage.ID = this.damageData.damage.ID;
            for (let i = 0; i < this.damageData.poleData.damages.length; i++)
                if (this.damageData.poleData.damages[i].ID == this.damage.ID) {
                    this.damageData.poleData.damages.splice(i, 1);
                    break;
                }

        }
        this.damageData.poleData.damages.push(this.damage);
        if (store.getters.fromFulcrum) {
            this.backToEvaluation();
        }
        else {
            this.saveDamageRecords(damageKey, JSON.stringify(this.damage));
        }
    },

    saveDamageRecords(key, val) {
        let self = this;
        //debugger;
      if (this.damageData.damage) key = this.damageData.damage.ID;
      this.insertObject("damage-data", "SASC_DB", key, val)
        .then(() => {
          self.backToEvaluation();
        })
        .catch((err) => {
          console.log(err);
        });
    },

      backToEvaluation() {
          //debugger;
      store.dispatch("setPoleRecord", JSON.stringify(this.damageData.poleData));
      this.$router.replace("/evaluation");
    },

    insertObject(store, db_name, key, val) {
      try {
        let jsonVal = val.includes("{") ? JSON.parse(val) : val;
        return SimpleIDB.SimpleIDB.set(key, jsonVal, store, db_name);
      } catch (e) {
        console.log(e);
      }
    },

    decimalPoint($event, val) {
      try {
        let newVal = $event.clipboardData.getData("text");
        if (newVal) {
          if ((parseFloat(newVal) * 100) % 1 > 0) {
            $event.preventDefault();
            return false;
          }
        }
      } catch {
        if (
          val != null &&
          val.toString().indexOf(".") > -1 &&
          val.toString().split(".")[1].length > 1
        ) {
          $event.preventDefault();
          return false;
        }
      }
    },

    onCancel() {
      if (
        this.damage.shellQuads.shellLoL !== "" ||
        this.damage.shellQuads.shell90 !== "" ||
        this.damage.shellQuads.shell_LoL !== "" ||
        this.damage.shellQuads.shell_90 !== ""
      ) {
          //debugger;
        this.clearEnPoc = false;
        this.popupMsg = "Changes will not be saved. Continue?";
        this.popup = true;
      } else this.$router.go(-1);
    },
  },
};
</script>

<style scoped lang="scss">
.oDesign {
  position: relative;
  margin: 50px 0px 40px 0px;
}
.ml-2 {
  margin-left: 6px;
}
.imgIcon {
  width: 30px;
  margin-right: 12px;
  position: relative;
  top: -3px;
}
.arrowMain {
  width: 72px;
  height: 32px;
  background: #fff;
  border-radius: 6px 0px 0px 6px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-60%, -50%);
}
.arrow-right {
  width: 0;
  height: 0;
  border-top: 25px solid transparent;
  border-bottom: 25px solid transparent;
  border-left: 25px solid #fff;
  float: right;
  margin-top: -9px;
  margin-right: -17px;
  border-radius: 5px 0px 0px 5px;
  span {
    position: absolute;
    width: 100%;
    font-size: 10px;
    font-weight: 800;
    color: #000;
    top: 10px;
    left: 5px;
  }
}
.spinNone::-webkit-inner-spin-button,
.spinNone::-webkit-outer-spin-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin: 0;
}
.popupText {
  padding: 20px 20px;
}
.modalFooter {
  border-top: 1px solid #d5d5d5;
  padding: 10px 10px;
}
.btnRounded {
  background: #f1f1f1;
  border: 2px solid #f1f1f1;
  padding: 6px;
  border-radius: 50px;
  color: #2c95ff;
  min-width: 90px;
  cursor: pointer;
}
.btnRoundedFull {
  background: #2c95ff;
  border: 2px solid #2c95ff;
  padding: 6px;
  border-radius: 50px;
  color: #fff;
  min-width: 90px;
  cursor: pointer;
}
.circle-container {
  position: relative;
  width: 10em;
  height: 10em;
  padding: 0;
  border-radius: 50%;
  list-style: none;
  margin: auto;
  border: solid 0px #4797ff;
  button {
    height: 40px;
    width: 40px;
    padding: 0px;
    border-radius: 8px;
    font-size: 12px;
    text-align: center;
    color: #000;
    font-weight: 600;
    cursor: pointer;
    background: #fff;
    border: 0px;
  }
}

.circle-container > * {
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 3em;
  height: 3em;
  margin: -1.5em;
}

.circle-container > *:nth-of-type(1) {
  transform: rotate(0deg) translate(5em) rotate(0deg);
}
.circle-container > *:nth-of-type(2) {
  transform: rotate(45deg) translate(5em) rotate(0deg);
  button {
    span {
      transform: rotate(-45deg);
      display: inline-block;
    }
  }
}
.circle-container > *:nth-of-type(3) {
  transform: rotate(90deg) translate(5em) rotate(-90deg);
}
.circle-container > *:nth-of-type(4) {
  transform: rotate(135deg) translate(5em) rotate(-90deg);
  button {
    span {
      transform: rotate(-45deg);
      display: inline-block;
    }
  }
}
.circle-container > *:nth-of-type(5) {
  transform: rotate(180deg) translate(5em) rotate(-180deg);
}
.circle-container > *:nth-of-type(6) {
  transform: rotate(225deg) translate(5em) rotate(-180deg);
  button {
    span {
      transform: rotate(-45deg);
      display: inline-block;
    }
  }
}
.circle-container > *:nth-of-type(7) {
  transform: rotate(270deg) translate(5em) rotate(-270deg);
}
.circle-container > *:nth-of-type(8) {
  transform: rotate(315deg) translate(5em) rotate(-280deg);
  button {
    span {
      transform: rotate(-35deg);
      display: inline-block;
    }
  }
}

.selectDrop {
  background: #003468;
  border-radius: 3px;
  margin-bottom: 15px;
  padding: 10px;
  position: relative;
  min-height: 80px;

  height: auto;
  transition-property: all;
  transition-duration: 1s;
  .closeselectDrop {
    color: #fff;
    font-weight: bold;
    font-size: 14px;
    position: absolute;
    right: 12px;
    top: 12px;
    cursor: pointer;
  }
}
.delRecord {
  position: absolute;
  right: 0px;
  text-decoration: none;
  top: 10px;
  display: block;
  z-index: 1;
  img {
    width: 20px;
  }
}
.posRel {
  position: relative;
}
.formList {
  position: relative;
  padding-bottom: 20px;
  .formControl {
    width: 82%;
  }
}
.formAbsAuto {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
}
.errormsgBorder {
  border: 1px solid #ff0000 !important;
}
.popupText {
  padding: 20px 20px;
}
.modalFooter {
  border-top: 1px solid #d5d5d5;
  padding: 10px 10px;
}
.popUp {
  text-align: center;
  position: fixed;
  top: 0px;
  background: rgba(0, 0, 0, 0.2);
  width: 100%;
  height: 100%;
  z-index: 1;
}
.popUpBox {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 0px 5px #d2e4ff;
  width: 230px;
  margin: auto;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.mainPage {
  height: calc(100vh - 50px);
}
.delRecord {
  color: #ff0000;
  font-weight: bold;
  font-size: 14px;
  position: absolute;
}
.headerLogo {
  img {
    width: 230px;
  }
}
.poleId {
  font-size: 16px;
  font-weight: normal;
  margin: 10px 0px;
  text-align: center;
}
.mainPageContent {
  margin: auto;
}
.listInline {
  list-style: none;
  padding-left: 0;
  font-size: 14px;
  margin: 1rem 0px;
  .listItem {
    display: inline-block;
    margin-right: 1rem;
    a {
      text-decoration: none;
    }
  }
  .listItem:last-child {
    margin-right: 0rem;
  }
}

.title1 {
  margin: 3% 0px;
  text-align: center;
  color: #003468;
  font-weight: 600;
  font-size: 20px;
}
.btndef {
  background: #d5d5d5;
  border-radius: 8px;
  padding: 16px;
  color: #fff;
  font-size: 14px;
  border: 0px;
  cursor: pointer;
  font-weight: 600;
  width: 100%;
  margin: 18px 0px;
  pointer-events: none;
}
.btnblue {
  background: #003468;
  border-radius: 8px;
  padding: 16px;
  color: #fff;
  font-size: 14px;
  border: 0px;
  cursor: pointer;
  font-weight: 600;
  width: 100%;
  margin: 18px 0px;
  pointer-events: all !important;
}
.error {
  color: #ff0000;
  font-size: 12px;
}
.bottomFixed {
  position: fixed;
  bottom: 0px;
  width: 100%;
  text-align: center;
  background: #fff;
  z-index: 1;
  .listInline a {
    color: #003468;
  }
}
.backLink {
  color: #003468;
  font-size: 16px;
  text-decoration: none;
  font-weight: 600;
}
.contentPanel {
  width: 350px;
  text-align: center;
  margin: auto;
  padding-top: 2rem;
  padding-bottom: 50px;
}
.info1 {
  color: #003468;
  font-size: 14px;
  font-weight: 600;
  margin: 16px 0px;
}
.fnt24 {
  font-size: 24px;
}
.fntBold16 {
  font-size: 16px;
  font-weight: bold;
  margin: 20px 0px 12px 0px;
}
.ml-1 {
  margin-left: 16px;
}
.internetOffline {
  position: fixed;
  bottom: 0px;
  z-index: 10;
  width: 100%;
  background: #000;
  margin: auto;
  color: #fff;
  font-size: 14px;
  padding: 10px;
}
.offlineMsg {
  width: 300px;
  display: flex;
  align-items: center;
  margin: auto;
  text-align: left;
  line-height: 16px;
  img {
    height: 22px;
    opacity: 0.8;
  }
}
.damageDet {
  label {
    flex: 100%;
  }
  .formGroup {
    align-items: center;
    display: flex;
  }
}
.damageCard {
  border-top: 1px solid #d6d6d6;
  padding: 5px 0px;
  margin: 18px 0px 0px 0px;
  position: relative;
}
.Box1 {
  padding: 15px 0px;
  cursor: pointer;
}
.listBox {
  margin: auto;
  color: #003468;
  font-size: 18px;
  display: flex;
  align-items: center;
}
.boxTitle {
  margin-left: 20px;
}
.flex-1 {
  flex: 25%;
  margin: 0px;
  padding: 12px;
}
//Tabs Only
@media (min-width: 768px) {
  .contentPanel {
    padding-top: 5rem;
  }
  .info1 {
    margin: 4rem 0px;
  }
  .listInline {
    margin: 2rem 0px;
  }
  //   .headerLogo{
  //   img{
  //     width: 230px;
  //     height: 48px;
  //   }
  // }
}
//Desktop only
@media (min-width: 1200px) {
  .listInline {
    margin: 1rem 0px;
  }
  .contentPanel {
    padding-top: 1rem;
  }
  .info1 {
    margin: 1rem 0px;
  }
  .title1 {
    margin: 3% 0px;
  }
}

//Small mobile
@media (max-width: 374.5px) {
  .contentPanel {
    width: 90% !important;
  }
}
</style>
